<div class="counter-container" [ngStyle]="{'background-color': cardColor || parseWashedColor(titleColor)}">
  <span [ngStyle]="{'background-color': titleColor, 'color': textColor}" class="counter-title">{{title}}</span>
  <span class="counter-value">{{value}}</span>
</div>
